import { Component, Inject, OnInit, Self } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UnsubscribeService } from '../../shared/services/unsubscribe.service';
import { distinctUntilChanged, map, takeUntil, tap } from 'rxjs/operators';
import { EnvironmentType } from '../../models/environment.type';
import { ENVIRONMENT } from '@libs/shared/injections/window';

@Component({
  selector: 'app-landing',
  template: '<router-outlet></router-outlet> <app-chat-helpcranch></app-chat-helpcranch>',
  providers: [UnsubscribeService],
})
export class LandingComponent implements OnInit {
  constructor(
    @Self() private destroyStream$: UnsubscribeService,
    @Inject(ENVIRONMENT) private environment: EnvironmentType,
    private route: ActivatedRoute,
    private cookieService: CookieService,
  ) {}

  public ngOnInit(): void {
    this.initCookiesParams();
  }

  private initCookiesParams(): void {
    this.route.queryParamMap
      .pipe(
        map((params: Params) => params.params),
        distinctUntilChanged(),
        tap((params: Params) => {
          if (params['department'] === 'in_house') {
            this.clearCookies();
          }
          this.affiliateCookieFactory(params);
        }),
        takeUntil(this.destroyStream$),
      )
      .subscribe();
  }

  private clearCookies(): void {
    this.cookieService.deleteAll('/', this.environment.cookieDomain);
    this.cookieService.deleteAll('/', `click${this.environment.cookieDomain}`);
  }

  private affiliateCookieFactory(params: Params): void {
    Object.keys(params).forEach((key: string) => {
      this.cookieService.set(key, params[key], 30, '/', this.environment.cookieDomain);
    });
    if (params['clickid']) {
      this.cookieService.set('referrer', params['clickid'], 30, '/', this.environment.cookieDomain);
    }
  }
}
